import React, { useRef, useEffect } from 'react';

const MessageAlerts = ({ inCompleteMessage, errorMessage }) => {
  // The save-error banner renders at the bottom of the form, below the fold on the tall /mcc price forms, so a
  // user who submits from the top never sees why the save failed. Scroll it into view when it appears.
  const errorMessageRef = useRef(null);

  useEffect(() => {
    if (errorMessage && errorMessageRef.current) {
      errorMessageRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [errorMessage]);

  if (!inCompleteMessage && !errorMessage) {
    return null;
  }

  return (
    <>
      {inCompleteMessage && (
        <div className="alert alert-danger fade in">
          <i className="fa fa-exclamation-circle"></i>
          &nbsp;
          <strong>
            <span dangerouslySetInnerHTML={{__html: inCompleteMessage}}></span>
          </strong>
        </div>
      )}

      {errorMessage && (
        <div ref={errorMessageRef} className="alert alert-danger fade in">
          <i className="fa fa-exclamation-circle"></i>
          &nbsp;
          <strong>
            <span dangerouslySetInnerHTML={{__html: errorMessage}}></span>
          </strong>
        </div>
      )}
    </>
  );
};

export default MessageAlerts;